import { render, staticRenderFns } from "./brandbar.vue?vue&type=template&id=366f2e3a&scoped=true&"
import script from "./brandbar.vue?vue&type=script&lang=js&"
export * from "./brandbar.vue?vue&type=script&lang=js&"
import style0 from "./brandbar.vue?vue&type=style&index=0&id=366f2e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f2e3a",
  null
  
)

export default component.exports